(() => {
  if (customElements.get('ranked-collection')) return;
  const requests = new Map();

  function loadCards(url) {
    const key = url.toString();
    if (!requests.has(key)) {
      requests.set(key, fetch(url, { credentials: 'same-origin' }).then(async response => {
        if (!response.ok) throw new Error('Products unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const container = html.querySelector('[data-ranked-product-cards]');
        if (!container) throw new Error('Product section missing');
        return Array.from(container.querySelectorAll('product-card'));
      }).catch(error => {
        requests.delete(key);
        throw error;
      }));
    }
    return requests.get(key);
  }

  customElements.define('ranked-collection', class extends HTMLElement {
    async connectedCallback() {
      if (this.loaded || this.loading) return;
      const template = this.querySelector('[data-ranked-template]');
      const mount = this.querySelector('[data-ranked-mount]');
      const content = template ? template.content.cloneNode(true) : null;
      const list = (content || this).querySelector('[data-ranked-list]');
      const status = this.querySelector('[data-ranked-status]');
      if (!list || !status) return;
      this.loading = true;
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('section_id', 'ranked-product-cards');
        const cards = await loadCards(url);
        if (!this.isConnected) return;
        const limit = Math.max(2, Math.min(20, Number(this.dataset.limit) || 8));
        list.replaceChildren(...cards.slice(0, limit).map(card => card.cloneNode(true)));
        // Connect the carousel only after it contains cards: the theme caches
        // its items and attaches navigation handlers on first connection.
        if (content && mount && cards.length) mount.replaceChildren(content);
        status.textContent = cards.length ? '' : 'No products to show yet.';
        status.hidden = cards.length > 0;
        this.loaded = true;
      } catch (error) {
        if (this.isConnected) status.textContent = 'Products could not be loaded. Please refresh the page or use the collection link above.';
      } finally {
        this.loading = false;
        list.setAttribute('aria-busy', 'false');
      }
    }
  });
})();
